import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve, Router,
  RouterStateSnapshot
} from '@angular/router';
import { Select2OptionData } from 'ng-select2';

import { DateService } from '../../app/common';
import { GetCitiesService } from '../common/get-cities.service';

@Injectable()
export class ShellResolver implements Resolve<any> {
  city: string;
  cities: Array<Select2OptionData>;

constructor(
    private getCitiesService: GetCitiesService,
    private router: Router,
    private dateService: DateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {

if (this.getCitiesService.citiesList().length) {
      this.cities = this.getCitiesService.citiesList();
      this.city = localStorage.getItem('sg_city_id') || this.cities[0].id;
      const currentCity = this.cities.find((city) => this.city === String(city.id));
      this.dateService.setCity(currentCity);
      resolve(false);
    } else {
      this.getCitiesService.getCities()
        .subscribe((cities: any) => {
          this.cities = cities;
          this.getCitiesService.citiesList(cities);
          this.city = localStorage.getItem('sg_city_id') || cities[0].id;
          const currentCity = this.cities.find((city) => this.city === String(city.id));
          this.dateService.setCity(currentCity);
          resolve(false);
        });
    }
    });

}
}
